module.exports = __webpack_public_path__ + "static/media/achievement-active-household.25495601.svg";